import { useQuery } from '@tanstack/react-query';
import type { ReactNode } from 'react';
import { consultorio } from '../api/recursos';
import { useApariencia } from '../diseno/Apariencia';
import { useSesion } from '../sesion/SesionProvider';
import { ProveedorDeMarca } from './ProveedorDeMarca';
import type { Marca } from './tipos';

/**
 * Aplica la marca del consultorio de quien esta dentro.
 *
 * Mientras no hay sesion se usa la marca neutral. Ese es el motivo de que exista
 * este envoltorio en lugar de leer la marca en el proveedor: el proveedor no
 * debe saber nada de sesiones ni de peticiones.
 */
export function MarcaDelConsultorio({ children }: { children: ReactNode }) {
  const { usuario } = useSesion();
  const { modo } = useApariencia();

  const consulta = useQuery({
    queryKey: ['consultorio'],
    queryFn: consultorio.detalle,
    enabled: Boolean(usuario),
    staleTime: 5 * 60 * 1000,
  });

  const marca: Marca | null = consulta.data
    ? {
        nombreComercial: consulta.data.marca.nombreComercial,
        colorPrimario: consulta.data.marca.colorPrimario,
        colorSecundario: consulta.data.marca.colorSecundario,
        logoUrl: consulta.data.marca.logoUrl,
        membrete: consulta.data.marca.membrete,
        pieDePagina: consulta.data.marca.pieDePagina,
      }
    : null;

  return (
    <ProveedorDeMarca marca={marca} cargando={consulta.isPending} modo={modo}>
      {children}
    </ProveedorDeMarca>
  );
}
